import {
	Avatar,
	getAvatarFilePath,
	getRunnitLayerDownloadFilePath,
	getRunnitNodeRunResultFilePath,
	getRunnitUploadFilePath,
	RUNNIT_NODE_RUN_RESULT_TYPE,
	RunnitNodeRunResult,
	RunnitUpload,
} from '@run-diffusion/shared';
import { storage } from '@/firebase';

/**
 * Resolve Firebase Storage download URL + filename for a runnit upload, node result, or avatar.
 * Shared by RunnitBulkActionsMixin and components that only need this (no bulk menu mixin).
 */
export async function fetchRunnitImageSrc (
	input: RunnitNodeRunResult | RunnitUpload | Avatar,
	useCase: 'nodeRunResult' | 'upload' | 'avatar'
): Promise<{ fileName: string; imageUrl: string }> {
	const nodeRunResult: RunnitNodeRunResult = input as RunnitNodeRunResult;
	const upload: RunnitUpload = input as RunnitUpload;
	const avatar: Avatar = input as Avatar;

	let filePath: string | undefined;
	let fileName: string | undefined;
	if (useCase === 'upload') {
		const filePathData: { filePath: string } = getRunnitUploadFilePath(upload);
		filePath = filePathData.filePath;
		fileName = upload.name;
	} else if (useCase === 'nodeRunResult') {
		if (nodeRunResult.type === RUNNIT_NODE_RUN_RESULT_TYPE.LAYERS && nodeRunResult.downloadFile) {
			const filePathData: { filePath: string } = getRunnitLayerDownloadFilePath(nodeRunResult);
			filePath = filePathData.filePath;
			fileName = nodeRunResult.downloadFile.name;
		} else {
			const filePathData: { filePath: string } = getRunnitNodeRunResultFilePath(nodeRunResult);
			filePath = filePathData.filePath;
			fileName = nodeRunResult.file.name;
		}
	} else if (useCase === 'avatar') {
		const filePathData: { filePath: string } = getAvatarFilePath(avatar);
		filePath = filePathData.filePath;
		fileName = avatar.name;
	}

	if (!fileName || !filePath) {
		throw new Error('cannot find image');
	}
	const fileRef = storage.ref(filePath);
	const imageUrl: string = await fileRef.getDownloadURL();
	return { fileName, imageUrl };
}
